import { isThemeMode } from "../utils/theme.js";
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
import { ThemeProvider } from "next-themes";
//#region src/providers/theme.tsx
const DEFAULT_THEME_MODE = "system";
const THEME_STORAGE_KEY = "theme";
/**
* Repairs an invalid persisted theme value.
*/
const resetInvalidPersistedTheme = () => {
	if (typeof window !== "undefined") {
		const persistedTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
		if (!isThemeMode(persistedTheme)) window.localStorage.setItem(THEME_STORAGE_KEY, DEFAULT_THEME_MODE);
	}
};
const ThemeProvider$1 = ({ children }) => {
	useState(resetInvalidPersistedTheme);
	return /* @__PURE__ */ jsx(ThemeProvider, {
		disableTransitionOnChange: true,
		attribute: "class",
		storageKey: THEME_STORAGE_KEY,
		themes: ["light", "dark"],
		children
	});
};
//#endregion
export { ThemeProvider$1 as ThemeProvider };

//# sourceMappingURL=theme.js.map